"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockMitekDecision = void 0;
const features_1 = require("../../features");
const initializer_1 = require("../../initializer");
const mockMitekDecision = (progressId) => {
    return (0, features_1.mockMitekDecision)(initializer_1.API, progressId);
};
exports.mockMitekDecision = mockMitekDecision;
//# sourceMappingURL=mockMitekDecision.js.map